module.exports = __webpack_public_path__ + "img/benefit_02_obj.0ea8a0dc.jpg";